import React from 'react';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Paper,
  Avatar,
} from '@mui/material';
import { SelfImprovement as MeditationIcon } from '@mui/icons-material';

const LoadingScreen: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={4}
          sx={{
            p: 4,
            borderRadius: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            width: '100%',
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Avatar
              sx={{
                width: 60,
                height: 60,
                mx: 'auto',
                mb: 2,
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              }}
            >
              <MeditationIcon sx={{ fontSize: 30 }} />
            </Avatar>
            <Typography variant="h5" component="h1" gutterBottom>
              Lumina
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9 }}>
              Preparing your meditation experience...
            </Typography>
          </Box>

          <CircularProgress 
            size={40} 
            sx={{ 
              color: 'white',
              mb: 2
            }} 
          />
          
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Loading your personalized journey
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoadingScreen;
